module.exports = __webpack_public_path__ + "img/tools_relocation_banner.33bf7415.jpg";